var HashSet = require("../collections/hashSet.js");
var SortedMap = require("../collections/sortedMap.js");
var inherit = require("../general.js").inherit;
var sanityCheckHandler = require("./sanityCheckHandler.js");

var ObservableSet = function(validator){
    HashSet.call(this);

    if (typeof validator == "function") this.validator = validator;

    this.handlers = {
        add: null,
        addFail: null,
        remove: null
    };
};
inherit(ObservableSet, HashSet);

ObservableSet.prototype.getType = function(){return "set"};

ObservableSet.prototype.add = function(val){
    var self = this;
    if (!this.contains(val)){
        var validated = !this.validator || this.validator(val);
        if(validated) {
            HashSet.prototype.add.call(this, val);
            this.handlers.add && this.handlers.add.forEach(function(k, handler){
                handler.call(self, val, val);
            });
        } else {
            this.handlers.addFail && this.handlers.addFail.forEach(function(k, handler){
                handler.call(self, val, val);
            });
        }
        return validated;
    } else return true;
};

ObservableSet.prototype.remove = function(val) {
    var self = this;
    if (this.contains(val)) {
        HashSet.prototype.remove.call(this, val);
        this.handlers.remove && this.handlers.remove.forEach(function(k, handler){
            handler.call(self, val, val);
        });
        return val;
    }
};

ObservableSet.prototype.onAdd = function(key, handler, priority) {  // handlers without priority get default priority 0 and are sorted in insertion order
    sanityCheckHandler(arguments);
    if(!this.handlers.add) this.handlers.add = new SortedMap();
    this.handlers.add.put(key, handler, priority || 0);
};

ObservableSet.prototype.onAddFail = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.addFail) this.handlers.addFail = new SortedMap();
    this.handlers.addFail.put(key, handler, priority || 0);
};

ObservableSet.prototype.onRemove = function(key, handler, priority) {
    sanityCheckHandler(arguments);
    if(!this.handlers.remove) this.handlers.remove = new SortedMap();
    this.handlers.remove.put(key, handler, priority || 0);
};

ObservableSet.prototype.removeHandlers = function(key){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].remove(key);
            this._cleanHandlers(type);
        }
    }
};

ObservableSet.prototype.removeAllHandlers = function(col){
    for (var type in this.handlers) {
        if(this.handlers[type]) {
            this.handlers[type].removeAll(col);
            this._cleanHandlers(type);
        }
    }
};

ObservableSet.prototype.removeHandlersWhere = function(f){
    for (var type in this.handlers){
        if(this.handlers[type]) {
            this.handlers[type].removeWhere(f);
            this._cleanHandlers(type);
        }
    }
};

ObservableSet.prototype._cleanHandlers = function(type) {
    if(this.handlers[type].size() == 0)
        this.handlers[type] = null;
};

module.exports = ObservableSet;